var ApiClient = (function() {
  function ApiClient() {
  };

  ApiClient.prototype.get = function (url, data) {
    return this.send('GET', url, data);
  };

  ApiClient.prototype.post = function (url, data) {
    return this.send('POST', url, data);
  };

  ApiClient.prototype.put = function (url, data) {
    return this.send('PUT', url, data);
  };

  ApiClient.prototype.delete = function (url, data) {
    return this.send('DELETE', url, data);
  };

  ApiClient.prototype.send = function(method, url, data) {
    return new Promise((resolve, reject) => {
      $.ajax({
          url: Url.action(url),
          type: method,
          dataType: 'json',
          data: data
        })
        .done(response => resolve(response))
        .fail((xhr, textStatus, errorThrown) => reject(new Exception(errorThrown, xhr.responseJSON)));
    });
  };

  ApiClient.prototype.load = function (url) {
    return new Promise((resolve, reject) => {
      $.ajax({
          url: Url.action(url),
          type: 'GET'
        })
        .done(response => resolve(response))
        .fail((xhr, textStatus, errorThrown) => reject(errorThrown));
    });


    
  };

  return ApiClient;
}());
